class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.detailsContainer = this.querySelector('details > *:last-child');
    this.summaryToggle = this.querySelector('summary');
    this.announcementWrapper = document.querySelector('.announcement-outer-wrapper');
    this.announcementSection = document.querySelector('.announcement-bar-section');
    this.closeButton = this.querySelector('button[type="button"]');

    this.detailsContainer?.addEventListener(
      'transitionend',
      (event) => {
        if (event.propertyName === 'visibility' && !this.mainDetailsToggle.hasAttribute('open')) {
          this.detailsContainer.removeAttribute('style');
        }
      }
    );

    this.summaryToggle?.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    }

    this.summaryToggle?.setAttribute('role', 'button');
  }

  isOpen() {
    return this.mainDetailsToggle.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    event.target.closest('details').hasAttribute('open')
      ? this.closeModal(event, true)
      : this.openModal();
  }

  onBodyClick(event) {
    // Check if click is on overlay or close button
    const isOverlayClick = event.target.classList.contains('modal-overlay');
    const isCloseButtonClick = event.target.closest('.search-modal__close-button');
    const isSearchContent = event.target.closest('.search-modal__content');
    
    // Only close if clicking overlay (but not search content) or close button
    if ((isOverlayClick && !isSearchContent) || isCloseButtonClick) {
      event.preventDefault();
      event.stopPropagation();
      
      // Close cloud search results if they exist
      const cloudSearchResults = document.getElementById('cloud-search-results');
      if (cloudSearchResults) {
        // Add cloud search backdrop
        cloudSearchResults.classList.add('cloud-search-mobile');
        const backdrop = document.createElement('div');
        backdrop.classList.add('cloud-search-mobile-backdrop');
        document.body.appendChild(backdrop);
        
        // Clear search input
        const searchInput = document.querySelector('.search__input');
        if (searchInput) {
          searchInput.value = '';
        }
        
        cloudSearchResults.remove();
        backdrop.remove();
      }
      
      this.close(false);
    }
  }

  openModal() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    
    // Disable scrolling without messing with position
    document.body.style.overflow = 'hidden';
    
    this.mainDetailsToggle.setAttribute('open', '');
    
    // Add class only to search-modal parent to trigger transition
    const searchModal = this.mainDetailsToggle.querySelector('.search-modal');
    
    // Use requestAnimationFrame to ensure the transition happens
    requestAnimationFrame(() => {
      if (searchModal) {
        searchModal.classList.add('search-modal--open');
      }
    });

    // Focus the first focusable element (usually the search input)
    const firstFocusable = this.mainDetailsToggle.querySelector('input:not([type="hidden"]), button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      firstFocusable.focus({ preventScroll: true });
    }
  }

  closeModal(event, animating = true) {
    if (event) event.preventDefault();
    document.body.removeEventListener('click', this.onBodyClickEvent);
    
    // Re-enable scrolling
    document.body.style.overflow = '';
    
    // Trigger closing animation by removing the class from search-modal parent only
    const searchModal = this.mainDetailsToggle.querySelector('.search-modal');
    
    if (searchModal) {
      searchModal.classList.remove('search-modal--open');
    }
    
    // Remove the open attribute after transition completes (0.5s transition duration)
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');

      if (animating) {
        this.detailsContainer.style.setProperty('visibility', 'visible');
      }
    }, 300);
  }

  close(animating = true) {
    this.closeModal(null, animating);
  }
}

customElements.define('details-modal', DetailsModal);
